import React, { useEffect, useState } from 'react';
import './header.css';
import logo from './SPK_HUB.png';

export default function Header() {
    function CustomLink({ href, children, onClick }) {
        const path = window.location.pathname;
        return (
            <li className={path === href ? "active" : ""} onClick={onClick}>
                <a href={href}>{children}</a>
            </li>
        );
    }
    const [currentDateTime, setCurrentDateTime] = useState(new Date());

    useEffect(() => {
      const intervalId = setInterval(() => {
        setCurrentDateTime(new Date());
      }, 1000);
  
      return () => clearInterval(intervalId); 
    }, []);
    return (
        <>
            <section id='header-section'>
                <div id='header-cont'>
                    <div id='mainicon'>
                    <div id='datetime'>
      {currentDateTime.toLocaleString()}
    </div>
                            <a href='/'><img src={logo} alt='SPK-HUB' /></a>
                            <div><span><a  href="https://www.instagram.com/prasanna_kumar_simmhadri_2005/?hl=en" 
              target="_blank" 
              rel="noopener noreferrer" 
              aria-label="Visit our Instagram profile"><ion-icon name="logo-instagram"></ion-icon></a></span>
                            <span><a   href="https://www.facebook.com/profile.php?id=100083873681403" 
              target="_blank" 
              rel="noopener noreferrer" 
              aria-label="Visit our Facebook page"><ion-icon name="logo-facebook"></ion-icon></a></span>
                            <span><a 
              href="https://x.com/Prasannak5002" 
              target="_blank" 
              rel="noopener noreferrer" 
              aria-label="Visit our Twitter profile"><ion-icon name="logo-twitter"></ion-icon></a></span>
                            <span><a  target="_blank" 
              rel="noopener noreferrer" 
             href='https://wa.me/8309179509
'><ion-icon name="logo-whatsapp"></ion-icon></a></span>
                       
                        </div> </div>
                    <ol>
                        
                        <CustomLink href='/'>Home</CustomLink>
                        <CustomLink href='/about'>About</CustomLink>
                       
                        <li>Converters
                            <ul>
                                <CustomLink href='/imagestopdf'>Images To PDF</CustomLink>
                                <CustomLink href='/texttopdf'>Text To PDF</CustomLink>
                                <CustomLink href='/imagetotext'>Image To Text</CustomLink>
                                <CustomLink href='/csvtojson'>CSV to JSON</CustomLink>
                                <CustomLink href='/jsontocsv'>JSON to CSV</CustomLink>
                            </ul>
                        </li>
                        <li>Engineering
                            <ul>
                                <CustomLink href='/findcgpa'>Find CGPA</CustomLink>
                                <CustomLink href='/findsgpa'>Find SGPA</CustomLink>
                                <CustomLink href='/typingtest'>Typing Test</CustomLink>
                            </ul>
                        </li>
                        
                       
                        <CustomLink href='/contact'>Contact</CustomLink>
                        <CustomLink href='/privacypolicy'>Privacy Policy</CustomLink>
                        <CustomLink href='/termsandconditions'>Terms & Conditions</CustomLink>                
                    </ol>
                </div>
                
            </section>
        </>
    );
}
